import { ArticleBuilder, IArticleBuilder } from "@sky-it-livedata/livedata-sports-design-system";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LmpPreviewArticleQuery  } from "./types";
import transformQuery from "./transformers/query";

export const disableClientRender = true;

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LmpPreviewArticleQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<LmpPreviewArticleQuery>):IArticleBuilder => {
  
  return transformQuery(props);
}

const LmpPreviewArticle = ({
  props,
  ...rest
}: WidgetContext<IArticleBuilder>) => {
  log({ props, ...rest });
  
  return (
    <ArticleBuilder {...props} />
  );
}

export default LmpPreviewArticle;